import React from 'react';
import { Text } from '@clockout-dev/design-elements';
import { clampPercent } from '../../../utils/numbers';
import SummaryCard from './SummaryCard';
import styles from './styles/bar-breakdown-card.module.scss';

function BarBreakdownCard({ title, subtitle, items = [] }) {
    return (
        <SummaryCard title={title} subtitle={subtitle}>
            <div className={styles.items}>
                {items.map((item) => (
                    <div className={styles.item} key={item.label}>
                        <div className={styles.itemHeader}>
                            <Text as="span" className={styles.itemLabel}>{item.label}</Text>
                            <Text as="span" className={styles.itemValue}>{item.value}</Text>
                        </div>
                        <div className={styles.track}>
                            <div
                                className={styles.fill}
                                style={{ width: `${clampPercent(item.percent)}%` }}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </SummaryCard>
    );
}

export default BarBreakdownCard;
